<div class="c-stories" fxLayout="column" fxLayoutAlign="center center">
  <h1>Cat Stories</h1>

  <div *ngFor="let catStory of catStories; let even = even; let last = last" fxLayout="column">
    <app-cat-story [catStory]="catStory" [even]="even" [last]="last"></app-cat-story>
  </div>

</div>
